"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IncludeExclude = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Row_1 = require("../../../components/Row");
var R = __importStar(require("../../../utils/ramda"));
var excludeMsg = {
  id: "label-exclude",
  defaultMessage: "Exclude"
};
var includeMsg = {
  id: "label-include",
  defaultMessage: "Include"
};
var RadioBtn = function (_a) {
  var mode = _a.mode,
    selectedMode = _a.selectedMode,
    filterId = _a.filterId,
    translation = _a.translation,
    onFireChange = _a.onFireChange;
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    gap: "small",
    align: "center"
  }, {
    children: [(0, jsx_runtime_1.jsx)("input", {
      style: {
        margin: 0,
        cursor: "pointer"
      },
      onClick: function () {
        return onFireChange(mode);
      },
      checked: selectedMode === mode,
      type: "radio",
      onChange: R.N,
      id: "".concat(mode, "_").concat(filterId),
      name: "include_exclude_".concat(filterId)
    }), (0, jsx_runtime_1.jsx)("label", __assign({
      htmlFor: "".concat(mode, "_").concat(filterId)
    }, {
      children: mode === "include" ? translation.include : translation.exclude
    }))]
  }));
};
var IncludeExclude = function (_a) {
  var filterId = _a.filterId,
    onChange = _a.onChange,
    translation = _a.translation,
    _b = _a.selectedMode,
    selectedMode = _b === void 0 ? "include" : _b;
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    gap: "medium",
    align: "center",
    className: "vsx-data-filter-include-exclude"
  }, {
    children: [(0, jsx_runtime_1.jsx)(RadioBtn, {
      mode: "include",
      translation: translation,
      selectedMode: selectedMode,
      onFireChange: onChange,
      filterId: filterId
    }), (0, jsx_runtime_1.jsx)(RadioBtn, {
      mode: "exclude",
      translation: translation,
      selectedMode: selectedMode,
      onFireChange: onChange,
      filterId: filterId
    })]
  }));
};
exports.IncludeExclude = IncludeExclude;